import DeltaWifiIntroBanner from './DeltaWifiIntroBanner';

export default DeltaWifiIntroBanner;
